import 'react-mde/lib/styles/css/react-mde-all.css';
import { LocalizedProvider } from '@synergy/components';
import { PaloShortcutProvider } from '@synergy/components-palo';
import { useEffect } from 'react';

import { AppRouter } from './app-router';
import { fetchContacts } from './common/actions/contact-actions';
import { localesSelector } from './common/selectors/locale-selectors';
import { useAppSelector } from './store/use-appstate-selector';
import { useThunkDispatch } from './store/use-thunk-dispatch';

export const App = () => {
    const dispatch = useThunkDispatch();
    const locales = useAppSelector(localesSelector);
    useEffect(() => {
        dispatch(fetchContacts());
    }, [dispatch]);

    return (
        <LocalizedProvider locales={locales}>
            <PaloShortcutProvider>
                <AppRouter />
            </PaloShortcutProvider>
        </LocalizedProvider>
    );
};
